const API = 'https://mixupbr.com.br/api';

function authHeaders(contentType = true) {
  const token = localStorage.getItem('mixup_loja_token');
  const h = {};
  if (contentType) h['Content-Type'] = 'application/json';
  if (token) h['Authorization'] = 'Bearer ' + token;
  return h;
}

export async function get(modulo, params = {}) {
  const query = new URLSearchParams(params).toString();
  const url = `${API}/${modulo}/${query ? '?' + query : ''}`;
  const res = await fetch(url, { headers: authHeaders(false) });
  return res.json();
}

export async function post(modulo, body) {
  const res = await fetch(`${API}/${modulo}/`, {
    method: 'POST',
    headers: authHeaders(true),
    body: JSON.stringify(body),
  });
  return res.json();
}

export async function put(modulo, id, body) {
  const res = await fetch(`${API}/${modulo}/?id=${id}`, {
    method: 'PUT',
    headers: authHeaders(true),
    body: JSON.stringify(body),
  });
  return res.json();
}

export async function del(modulo, id) {
  const res = await fetch(`${API}/${modulo}/?id=${id}`, {
    method: 'DELETE',
    headers: authHeaders(false),
  });
  return res.json();
}
